const BodyContent = () => {

    return (
        <div>
            
        </div>
    )

}

export default BodyContent;